import Flex from '@Components/Bases/Flex';
import { Alert, Box, Typography } from '@mui/material';

import GreenhouseStandardRemark, {
  GH_STANDARD_REMARK_ID,
} from './GreenhouseStandardRemark';
import GreenhouseStandardList from './GreenhouseStandardList';
import GreenhouseCompletedCheckbox from './GreenhouseCompletedCheckbox';

const GreenhouseStandard = () => {
  return (
    <Box>
      <Box p={2} bgcolor={'white'}>
        <Flex gap={1}>
          <Typography fontWeight={800}>
            การปฎิบัติตามหลักการและมาตรฐานด้านการจัดการก๊าซเรือนกระจกหรือการเปลี่ยนแปลงสภาพภูมิอากาศ
          </Typography>
          <Flex gap={0.5} alignItems={'center'}>
            <GreenhouseStandardRemark />
          </Flex>
        </Flex>
        <Alert severity={'info'} sx={{ mt: 2 }}>
          คำชี้แจง :
          กรุณาเลือกหลักการและมาตรฐานด้านก๊าซเรือนกระจกหรือการเปลี่ยนแปลงสภาพภูมิอากาศที่บริษัทปฏิบัติ
          โดยสามารถเลือกตอบได้หลายข้อ​​
        </Alert>
        <GreenhouseStandardList />
        <Box id={GH_STANDARD_REMARK_ID} />
      </Box>
      <GreenhouseCompletedCheckbox />
    </Box>
  );
};

export default GreenhouseStandard;
